/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Checkbox, focusBoxShadow, HFlow, Icon, Tag, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { AccordionAnimation } from 'components/accordion/AccordionAnimation'
import { useMemo } from 'react'
import { AccordionItem, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion'
import { TipoAtendimento, tipoAtendimentoHistorico } from 'types/enums'

export interface HistoricoAccordionProps {
  tipoAtendimento: TipoAtendimento
}

export default function HistoricoAccordion(props: HistoricoAccordionProps) {
  const { tipoAtendimento } = props
  const theme = useTheme()
  const tipoAtendimentoHistoricoData = tipoAtendimentoHistorico[tipoAtendimento]
  const classes = useMemo(() => styles(theme, tipoAtendimentoHistoricoData.colorBar), [
    theme,
    tipoAtendimentoHistoricoData.colorBar,
  ])

  return (
    <AccordionItem css={classes.accordionItem}>
      <AccordionAnimation>
        <AccordionItemButton css={classes.accordionButton}>
          <div css={classes.colorBar} />
          <div css={classes.accordionButtonContent}>
            <HFlow>
              <Checkbox
                style={css`
                  height: min-content;
                  padding-top: 0.2rem;
                  display: inline;
                `}
              />
              <VFlow vSpacing={0.5}>
                <HFlow
                  style={css`
                    display: inline-flex;
                  `}
                  alignItems='center'
                  hSpacing={0.5}
                >
                  <Icon
                    icon={tipoAtendimentoHistoricoData.icon}
                    name='iconTipoConsulta'
                    size={2}
                    color={tipoAtendimentoHistoricoData.colorIcon}
                  />
                  <Text
                    fontWeight='bold'
                    fontSize={1}
                    style={css`
                      color: ${tipoAtendimentoHistoricoData.colorIcon};
                    `}
                  >
                    {tipoAtendimentoHistoricoData.descricao}
                  </Text>
                  <Text
                    fontSize={1}
                    style={css`
                      color: ${tipoAtendimentoHistoricoData.colorIcon};
                    `}
                  >
                    | {/* CÓDIGO PARA TESTE - REMOVER */}
                  </Text>
                  <Text
                    fontSize={1}
                    style={css`
                      color: ${tipoAtendimentoHistoricoData.colorIcon};
                    `}
                  >
                    10:00 {/* CÓDIGO PARA TESTE - REMOVER */}
                  </Text>
                  <Tag
                    type='info'
                    style={css`
                      align-self: center;
                      max-height: 1.5rem;
                    `}
                  >
                    Consulta no dia
                  </Tag>
                  <Tag
                    type='danger'
                    style={css`
                      align-self: center;
                      max-height: 1.5rem;
                    `}
                  >
                    Urgente
                  </Tag>
                </HFlow>
                <Text>
                  Juliana Pires de Almeida - Médico da estratégia de saúde da família | Equipe 0000406031 - EN 1{' '}
                  {/* CÓDIGO PARA TESTE - REMOVER */}
                </Text>
                <HFlow>
                  <Text>
                    <b>INCHAÇO - A08</b> (CIAP2) | <b>ALTERAÇÕES NA TEXTURA DA PELE - R234</b> (CID10){' '}
                    {/* CÓDIGO PARA TESTE - REMOVER */}
                  </Text>
                  <div css={classes.problemaAvaliado}>
                    <Icon
                      size={1}
                      icon='infoCircleOutline'
                      style={css`
                        margin-right: 0.5rem;
                      `}
                    />
                    Avaliado mais problemas
                  </div>
                </HFlow>
                <HFlow>
                  <Tag
                    type='normal'
                    style={css`
                      align-self: center;
                      max-height: 1.5rem;
                    `}
                  >
                    Prescrição de medicamentos
                  </Tag>
                </HFlow>
              </VFlow>
            </HFlow>

            <Icon
              name='accordionAngleIcon'
              icon='angleDown'
              size={1.5}
              style={css`
                float: right;
              `}
            />
          </div>
        </AccordionItemButton>
        <AccordionItemPanel css={classes.accordionItemPanel}>
          {/** // TODO: CONTEÚDO DO ACCORDION */}
          {/* CÓDIGO PARA TESTE - REMOVER */}
          <VFlow>
            <span>asdsdjfgklhçj</span>
            <span>asdsdjfgklhçj</span>
            <span>asdsdjfgklhçj</span>
          </VFlow>
          {/* CÓDIGO PARA TESTE - REMOVER */}
        </AccordionItemPanel>
      </AccordionAnimation>
    </AccordionItem>
  )
}

const styles = (theme: Theme, colorBar: string) => {
  return {
    accordionItem: css`
      border: 1px solid ${theme.pallete.gray.c60};
      border-radius: 2px;
      &:focus-within {
        outline: none;
        box-shadow: ${focusBoxShadow(theme, 'primary')};
        transition-property: box-shadow;
        transition-duration: 0.2s;
      }
    `,
    accordionButton: css`
      display: flex;
      cursor: pointer;
      border-radius: 2px;
      border: 0px;
      &:focus {
        outline: none;
        box-shadow: none;
      }
      &:hover {
        background-color: ${theme.pallete.gray.c90};
      }
      &[aria-expanded='true'] div:first-of-type {
        border-bottom-left-radius: 2.5px;
      }
      &[aria-expanded='true'] {
        border-bottom: 1px solid ${theme.pallete.gray.c80};
      }
      &[aria-expanded='false'] {
        border-bottom: 0px;
      }
      &[aria-expanded='true'] svg[name='accordionAngleIcon'],
      &[aria-selected='true'] svg[name='accordionAngleIcon'] {
        transform: rotate(180deg);
        transition: 0.4s;
      }
      &[aria-expanded='false'] svg[name='accordionAngleIcon'] {
        transform: rotate(0deg);
        transition: 0.4s;
      }
    `,
    accordionButtonContent: css`
      justify-content: space-between;
      background-color: ${theme.pallete.surface.background};
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      padding: 1rem 0.5rem;
      display: flex;
      width: 100%;
    `,
    accordionItemPanel: css`
      padding: 0.5rem;
      flex: 1;
      background-color: ${theme.pallete.surface.main};
    `,
    colorBar: css`
      width: 0.5rem;
      background-color: ${colorBar};
      border-top-left-radius: 1px;
      border-bottom-left-radius: 1px;
    `,
    problemaAvaliado: css`
      color: ${theme.pallete.primary.main};
      display: flex;
      align-items: center;
    `,
  }
}
